module.exports = __webpack_public_path__ + "img/twitter.f5221056.png";